<template>
  <p>{{ label }} study variable <strong>{{details.name}}</strong> (<a :href="link">Link</a>)</p>
</template>

<script>
export default {
  name: "Variable",
  props: {
    details: {
      type: Object,
      default: function () {
        return {};
      }
    },
    label: {
      type: String,
      default: "Related to"
    }
  },
  inject: ['participantId'],
  computed: {
    link() {
      return `${this.$config.baseUrl}/admin/study/${this.$config.studyId}/participants/${this.participantId}/variableLedger`;
    },
  }
}
</script>

<style scoped>

</style>